import { DefaultPage } from './';

export default {
  path: 'vibe-coding/:version/v',
  name: 'Vibe Coding',
  childRoutes: [
    { path: ':projectId/chat', name: 'New Chat', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/chat/:conversationId',
      name: 'Chat Session',
      component: DefaultPage,
      isPrivate: true,
    },
  ],
};
